document.documentElement.classList.remove('no-js');

// Keep private contact details out of storefront policy and content pages.
document.addEventListener('DOMContentLoaded', () => {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach((node) => {
    node.nodeValue = node.nodeValue
      .replace(/please call \+1 206-228-0227 or email us at/gi, 'please email us at')
      .replace(/\+1[\s.-]*206[\s.-]*228[\s.-]*0227/g, '');
  });
});

document.querySelectorAll('[data-product-gallery-thumb]').forEach((button) => {
  button.addEventListener('click', () => {
    const image = document.querySelector('[data-product-gallery-image]');
    const video = document.querySelector('[data-product-gallery-video]');
    if (!image || !video) return;
    const isVideo = button.dataset.media === 'video';

    if (isVideo) {
      image.hidden = true;
      video.hidden = false;
      video.play().catch(() => {});
    } else {
      video.pause();
      video.hidden = true;
      image.hidden = false;
      image.src = button.dataset.src;
      image.alt = button.dataset.alt || '';
      image.classList.remove('is-front-product', 'is-unscratched-product');
      if (button.dataset.galleryClass) image.classList.add(button.dataset.galleryClass);
    }
    document.querySelectorAll('[data-product-gallery-thumb]').forEach((thumb) => {
      thumb.classList.toggle('is-active', thumb === button);
    });
  });
});

document.querySelectorAll('[data-preorder-quantity]').forEach((picker) => {
  const input = picker.querySelector('[data-quantity-input]');
  const decrease = picker.querySelector('[data-quantity-decrease]');
  const increase = picker.querySelector('[data-quantity-increase]');
  const form = picker.closest('form');
  const submit = form && form.querySelector('[data-preorder-submit]');

  if (!input || !decrease || !increase || !submit) return;

  const updateQuantity = (nextValue) => {
    const quantity = Math.max(0, Math.min(1, Number.parseInt(nextValue, 10) || 0));
    input.value = String(quantity);
    decrease.disabled = quantity === 0;
    increase.disabled = quantity === 1;
    submit.disabled = quantity !== 1;
  };

  decrease.addEventListener('click', () => updateQuantity(Number(input.value) - 1));
  increase.addEventListener('click', () => updateQuantity(Number(input.value) + 1));
  input.addEventListener('input', () => updateQuantity(input.value));
  input.addEventListener('change', () => updateQuantity(input.value));

  form.addEventListener('submit', async (event) => {
    if (Number(input.value) !== 1) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    submit.disabled = true;
    submit.textContent = 'Adding…';

    try {
      const variantId = Number(form.querySelector('[name="id"]').value);
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
      const existingItem = cart.items.find((item) => item.variant_id === variantId);

      if (existingItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: existingItem.key, quantity: 1 })
        });
      } else {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
      }

      window.location.assign('/cart');
    } catch (error) {
      submit.disabled = false;
      submit.textContent = 'Pre-order now';
      HTMLFormElement.prototype.submit.call(form);
    }
  });
  updateQuantity(input.value);
});

const menuButton = document.querySelector('[data-menu-button]');
const menu = document.querySelector('[data-menu]');

if (menuButton && menu) {
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    menu.classList.toggle('is-open', !open);
  });

  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      menuButton.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
    });
  });
}

const quiz = document.querySelector('[data-quiz]');

if (quiz) {
  const questions = [
    {
      question: 'Which game night vibe are you?',
      answers: [
        ['Read the rulebook cover to cover. Twice.', 'planner'],
        ['Skim the quick-start, learn as we go.', 'chaos']
      ]
    },
    {
      question: 'Pick your ideal game-night fuel.',
      answers: [
        ['A perfectly arranged snack board.', 'planner'],
        ['Whatever is closest to the table.', 'chaos']
      ]
    },
    {
      question: 'The score is tied. What happens next?',
      answers: [
        ['A carefully negotiated tiebreaker.', 'planner'],
        ['Sudden death. No questions asked.', 'chaos']
      ]
    }
  ];

  let current = 0;
  const scores = { planner: 0, chaos: 0 };
  const content = quiz.querySelector('[data-quiz-content]');

  const renderQuestion = () => {
    const item = questions[current];
    content.innerHTML = `
      <p class="marge-quiz__count">Question ${current + 1} of ${questions.length}</p>
      <h3>${item.question}</h3>
      <div class="marge-quiz__answers">
        ${item.answers.map(([label, score]) => `<button type="button" data-score="${score}">${label}</button>`).join('')}
      </div>`;

    content.querySelectorAll('[data-score]').forEach((button) => {
      button.addEventListener('click', () => {
        scores[button.dataset.score] += 1;
        current += 1;
        if (current < questions.length) renderQuestion();
        else renderResult();
      });
    });
  };

  const renderResult = () => {
    const plannerWins = scores.planner >= scores.chaos;
    content.innerHTML = `
      <p class="marge-quiz__count">Your game-night personality</p>
      <h3>${plannerWins ? 'The Delightful Director' : 'The Beautiful Wild Card'}</h3>
      <p>${plannerWins ? 'You bring the plan, the snacks, and the very satisfying score sheet.' : 'You bring the plot twists, the big laughs, and the rule interpretations nobody saw coming.'}</p>
      <button class="marge-button" type="button" data-restart-quiz>Play again</button>`;
    content.querySelector('[data-restart-quiz]').addEventListener('click', () => {
      current = 0;
      scores.planner = 0;
      scores.chaos = 0;
      renderQuestion();
    });
  };

  renderQuestion();
}
